<template>
  <div id="main_recon">
      <v-textarea
      class="text_box"
      v-show=!table
      rows=20
      solo
      name="name-input"
      label="Enter list of names here, one name on each line"
      v-model="names"
      >
    </v-textarea>

    <v-data-table
    v-show=table
    :headers="headers"
    :items="data"
    :rows-per-page-items=[25,50,100]
    item-key="name"
    >
    <template slot="headerCell" slot-scope="props">
      <v-tooltip bottom>
        <span slot="activator">
          {{ props.header.text }}
        </span>
        <span>
          {{ props.header.text }}
        </span>
      </v-tooltip>
    </template>
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ props.item[0] }}</td>
      <td class="text-xs-left">{{ props.item[1] }}</td>
      <td class="text-xs-left">{{ props.item[2] }}</td>
      <td class="text-xs-left">{{ props.item[3] }}</td>
    </template>
  </v-data-table>
  <div class="text-xs-right">
    <v-btn v-show=!table right ripple @click.native="submitNames">Submit Names</v-btn>
    <v-btn v-show=table right ripple @click.native="download">Download Names</v-btn>
    <v-btn v-show=table right ripple @click.native="editNames">Edit Names</v-btn>
  </div>
  </div>
</template>
<style>
  #main_recon {
    margin: 20px;
  }
  .text_box {
    vertical-align: top;
  }
</style>
<script>
  import api from '../lib/Api'
  import Papa from 'papaparse'
  import errorHandler from '../lib/ErrorHandler'
  import {globalStore} from '../main.js'
  export default {
    name: 'NameReconTable',
    data () {
      return {
        pagination: {},
        headers: [
          {text: 'Name', value: 'name'},
          {text: 'Matched', value: 'matched'},
          {text: 'IPNI id', value: 'ipniId'},
          {text: 'Matches', value: 'matches'}
        ],
        data: [],
        table: false,
        names: ""
      }
    },
    methods: {
      submitNames () {
        if(this.nameList.length <= 1000){
          var self = this
          api.match(this.nameList)
          .then(function(response){
            self.data = response.data.records
          }).catch(error => {
            this.handleAlert(errorHandler.handleError(error))
          });
          this.table = true
        }else{
          this.handleAlert("The simple matcher only works with a thousand names or less. Please use the CSV matcher for larger datasets")
        }
      },
      editNames () {
        this.table = false
      },
      download(){
        var downloadString = Papa.unparse(this.data, {
          delimiter: "\t"
        })
        api.download(downloadString, "matched_names")
      },
      handleAlert(alert){
        globalStore.messageText = alert
        globalStore.messageActive = true
        // eslint-disable-next-line
        console.log(globalStore.messageText)
      }
    },
    computed: {
      nameList () {
        return this.names.split(/\r|\n/)
      }
    }
  }
</script>
